module.exports = __webpack_public_path__ + "assets/images/tab_arrow.png";